import { RawDataSource } from '.';

import GroupedDataSource from './GroupedDataSource';

export interface RawGroupedDataSource {
	id: string;
	name: string;
	dataSources: RawDataSource[];
}

export default function mapGroupedDataSource(dataSource: RawGroupedDataSource): GroupedDataSource {
	return new GroupedDataSource({
		id: dataSource.id,
		name: dataSource.name,
		dataSources: dataSource.dataSources,
	});
}
